import { Environment } from './environment.types';

// Staging Firebase Web SDK config. Note: ghosts-ac-staging does not have a
// Realtime Database instance (only Firestore + Storage), so `databaseURL`
// is intentionally omitted. Production includes RTDB.
export const environment: Environment = {
  production: false,
  useEmulators: false,
  authenticatorIssuer: 'GHOSTS [staging]',
  anydatasetAppUrl: 'https://anydataset-staging.web.app',
  firebase: {
    projectId: 'ghosts-ac-staging',
    apiKey: 'AIzaSyAHqaeG0i7RYAvifukamC6uEeB0-kCZsd0',
    authDomain: 'ghosts-ac-staging.firebaseapp.com',
    storageBucket: 'ghosts-ac-staging.firebasestorage.app',
    messagingSenderId: '375656177226',
    appId: '1:375656177226:web:285bdfa949a00e634590b3',
    measurementId: 'G-WG8BJ4HSD7',
  },
};
